export const ENDPOINT_MANAGEMENT_FIND_ALL = '/api/management/list';
export const ENDPOINT_MANAGEMENT_FIND_ONE = '/api/management/get-one';
export const ENDPOINT_MANAGEMENT_CREATE_ONE = '/api/management/create';
export const ENDPOINT_MANAGEMENT_DELETE_ONE = '/api/management/delete';
export const ENDPOINT_MANAGEMENT_UPDATE_ONE = '/api/management/update';
